/* eslint-disable no-useless-catch */
import {useMutation, useQuery} from '@tanstack/react-query';

import {
  RQ_ADD_USER_API,
  RQ_GET_ALL_USER_API,
  RQ_GET_ALL_USER_PRODUCT_API,
  RQ_GET_OTP,
  RQ_GET_USER_API,
  RQ_GET_USER_DETAILS_API,
  RQ_VERIFY_OTP,
} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGetAllUsers = token => {
  console.log('RQGetAllUsers called with token:', token);

  return useQuery({
    queryKey: ['rq_get_all_users', token],
    queryFn: async () => {
      if (!token) {
        console.warn('RQGetAllUsers: Missing token');
        throw new Error('Token is required');
      }

      try {
        const response = await rqCreateRequest(RQ_GET_ALL_USER_API, null, token, null);

        console.log('All Users API response:', response);

        if (Array.isArray(response)) {
          return response;
        } else if (Array.isArray(response?.users)) {
          return response.users;
        } else {
          console.warn('Unexpected API response format:', response);
          return [];
        }
      } catch (error) {
        console.error('RQGetAllUsers error:', error);
        throw error;
      }
    },
    enabled: Boolean(token),
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RQGetUserAPI = (id, token, options={}) =>{
  return useQuery({
    queryKey: ['rq_get_user', {id, token}],
    queryFn: async({queryKey, signal}) =>{
      const {id, token} = queryKey[1];
      if (!token) {throw new Error('Invalid token: Token is required for API request');}

      const url = RQ_GET_USER_API.url;
  
      console.log('Get user data:', {url, token});

      try{
        const response = await rqCreateRequest(
          {...RQ_GET_USER_API, url},
          null,
          token,
          null,
          signal,
        );

        return response;
      } catch (error){
        throw error;
      }
    },
    ...options,
  });
};

export const RQGetUserDetails = (id, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_user_details', {id, token}],
    queryFn: async ({queryKey, signal}) => {
      const {id, token} = queryKey[1];
      if (!token) {throw new Error('Invalid token: Token is required for API request');}

      const url = RQ_GET_USER_DETAILS_API.url.replace('<%= id %>', id);

      try {
        const response = await rqCreateRequest(
          {...RQ_GET_USER_DETAILS_API, url},
          null,
          token,
          null,
          signal,
        );

        return response;
      } catch (error) {
        throw error;
      }
    },
    ...options,
  });
};

export const RQGetAllUserOrders = token => {
  console.log('rq get all users orders', token);
  return useQuery({
    queryKey: ['rq_get_all_users', token],
    queryFn: async () => {
      if (!token) {throw new Error('Token is required');}
      const response = await rqCreateRequest(RQ_GET_ALL_USER_PRODUCT_API, null, token, null);
      return response || [];
    },
    enabled: Boolean(token),
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RQAddUser = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_add_user'],
    mutationFn: async ({token, formData}) => {
      return rqCreateRequest(
        RQ_ADD_USER_API,
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};

export const RQGetOtp = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_get_otp'],
    mutationFn: async ({email}) => {
      const url = `${RQ_GET_OTP.url}?email=${encodeURIComponent(email)}`;
      return rqCreateRequest(
        {...RQ_GET_OTP, url: url},
        null,
        null,
        null,
      );
    },
    ...options,
  });
};

export const RQVerifyOtp = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_verify_otp'],
    mutationFn: async ({email, otp}) => {
      const url = `${RQ_VERIFY_OTP.url}?email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`;

      return rqCreateRequest(
        {...RQ_VERIFY_OTP, url: url},
        null,
        null,
        null,
      );
    },
    ...options,
  });
};
